type Props = React.PropsWithChildren<{
  title: React.ReactNode
}>
export const TitledChipList: React.FC<Props> = ({ title, children }) => {
  return (
    <section className="flex flex-col gap-3">
      <h3 className="text-[14px] font-bold leading-[1.4] xl:leading-none">
        {title}
      </h3>
      <ul className="flex flex-wrap gap-[6px]">{children}</ul>
    </section>
  )
}
